var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiVeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 176,
    viewBox: "0 0 384 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.558105 5.29297L43.6904 166.28H78.3177L64.2223 113.67H109.747L99.8751 80.2577H55.2703L35.1854 5.29297H0.558105Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.139 167.681L139.458 41.5934L104.224 40.2266L141.71 167.681H178.139Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.102 32.4097L337.573 0.441406L348.412 34.0783L306.386 65.7117L313.764 87.4889L355.673 56.6136L366.59 90.4963L360.429 95.1572L325.052 120.805L332.266 142.096L373.271 111.231L383.936 144.328L343.107 174.094L343.178 174.302L342.918 174.232L341.597 175.195L341.136 173.753L300.906 162.921L266.763 54.012L295.012 32.1421L295.102 32.4097Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.206 166.197L241.118 158.339L269.261 113.041L256.733 70.8962L221.003 125.866L211.814 95.9112H176.294L196.966 166.197H236.206ZM206.066 77.1738L195.158 41.6188L159.923 40.252L170.783 77.1738H206.066Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiVeLogo);
export default __webpack_public_path__ + "static/media/HIVeLogo.01c01a73db632d16eed52fe1d60173f0.svg";
export { ForwardRef as ReactComponent };